export const COURSEINCART_REQ = "courseInCartActionReq";
export const COURSEINCART_SUCCESS = "courseInCartActionSuccess";
export const COURSEINCART_FAIL = "courseInCartActionFail";
